import React from "react";
import { ArrowUpRight } from "lucide-react";
import { ORDER_LINKS } from "../data/menu";

const PARTNERS = [
  {
    name: "DoorDash",
    desc: "Delivered hot to your door, with DashPass available.",
    href: ORDER_LINKS.doordash,
    color: "bg-[#FF3008]",
    testid: "order-doordash",
  },
  {
    name: "Grubhub",
    desc: "Free delivery for Grubhub+ members.",
    href: ORDER_LINKS.grubhub,
    color: "bg-[#FB7C2E]",
    testid: "order-grubhub",
  },
  {
    name: "Order.Online",
    desc: "Direct pickup & delivery — no middlemen fees.",
    href: ORDER_LINKS.orderOnline,
    color: "bg-[#FF6392]",
    testid: "order-online-direct",
  },
];

export const OrderOnline = () => {
  return (
    <section className="relative py-20 sm:py-28 bg-[#FFE3EB]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
          <div className="max-w-xl">
            <p className="font-script text-[#FF6392] text-3xl -rotate-2 inline-block">order in seconds,</p>
            <h2 className="font-serif-display text-3xl sm:text-5xl lg:text-6xl text-[#2D2327] tracking-tight mt-2">
              Donuts, <span className="italic text-[#FF6392]">delivered.</span>
            </h2>
            <p className="mt-5 text-base sm:text-lg text-[#4A3F44]">
              Pick your platform. We&apos;ll have your box freshly packed and waiting.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {PARTNERS.map((p) => (
            <a
              key={p.name}
              href={p.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={p.testid}
              className="group relative overflow-hidden rounded-[2rem] bg-white p-6 sm:p-8 border border-white shadow-[0_12px_40px_rgba(0,0,0,0.06)] lift"
            >
              <div className={`absolute -top-10 -right-10 h-32 w-32 rounded-full ${p.color} opacity-90`} />
              <div className="relative">
                <span className="text-xs uppercase tracking-[0.22em] text-[#FF6392] font-semibold">Order via</span>
                <h3 className="mt-2 font-serif-display text-2xl sm:text-4xl text-[#2D2327]">{p.name}</h3>
                <p className="mt-3 text-[#4A3F44]">{p.desc}</p>
                <div className="mt-8 inline-flex items-center gap-2 text-[#2D2327] font-semibold group-hover:text-[#FF6392]">
                  Order now <ArrowUpRight className="h-4 w-4" />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OrderOnline;
